import React, { useEffect,useState} from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import Bread from '../component/Breadcrumbs';
import Sidebar from '../component/Sidebar';
import Datatable from '../component/Datatable';
import {UserList} from '../Services/User';
import {AuthData} from '../Services/Authdata';
import MaterialIcons from '../component/MaterialIcons';
import Button from '@material-ui/core/Button';
// import Swal from 'sweetalert2';
import {useParams} from 'react-router-dom';

// import List from '@material-ui/core/List';
// import ListItem from '@material-ui/core/ListItem';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
// import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
// import ListItemText from '@material-ui/core/ListItemText';
// import ListSubheader from '@material-ui/core/ListSubheader';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
}));


export default function UserTripList(props) {
    let { id } = useParams();
    const br = [{
      'title':'User',
      'icon':"",
      'url':'/user'
    },{
      'title':'User Trip',
      'icon':"",
      'url':'/user/trip/'+id
    }];

//console.log(id);
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [srow, setSrow] = useState([]);
  useEffect(() =>{
    UserList('user/trip/'+id,'GET',AuthData().token).then((result)=>{
      setData(result.data);
    })
  },[])

  const columns = [
    {
        name: "name",
        label: "Name",
        options: {
        filter: true,
        sort: true,
        }
    },
    {
        name: "destinations",
        label: "Destinations",
        options: {
            filter: true,
            sort: true,
            customBodyRenderLite:(value, dataIndex,updateValue) => {
              //console.log(data[dataIndex]);
              
              const dt = data[dataIndex].destinations.map((item,i)=>{
                return  <div><span>{item.from_place} - {item.to_place}</span><br></br></div>
              })
                return dt
                //return (data[dataIndex].image).replace(/[\[\]']+/g,'');
            }
        }
    },
    {
      name: "destinations",
      label: "Destinations Date",
      options: {
          filter: true,
          sort: true,
          customBodyRenderLite:(value, dataIndex,updateValue) => {
            //console.log(data[dataIndex]);
            
            const dt = data[dataIndex].destinations.map((item,i)=>{
              return  <div><span>{item.from_date} - {item.to_date}</span><br></br></div>
            })
              return dt
              //return (data[dataIndex].image).replace(/[\[\]']+/g,'');
          }
      }
  },
    {
      name: "people_count",
      label: "Peoples",
      options: {
          filter: true,
          sort: true,
          customBodyRenderLite:(value, dataIndex,updateValue) => {
            //console.log(data[dataIndex]);
            const pp = data[dataIndex].peoples.map((item)=>{
              //console.log(item)
              return <Avatar title={item.name} alt={item.name} src={"/faces/"+item.id+".jpg"} />
            })
              return <AvatarGroup max={2}>{pp}</AvatarGroup>
              //return (data[dataIndex].image).replace(/[\[\]']+/g,'');
          }
      }
  }
   ];
   const options = {
    filterType: 'dropdown',
    selectableRowsOnClick:false,
    responsive: "standard",
    onRowSelectionChange:(currentRowsSelected, allRowsSelected, rowsSelected) => {
       const abc = rowsSelected.map((r)=>{
         return data[r].id;
       })
        setSrow(abc);
    },
    customToolbarSelect:(selectedRows, displayData, setSelectedRows) =>{
     return (
       <div>
         <Button title="Block" >
           <MaterialIcons color="action" icon="verified_user" size={20}/>
       </Button>
       <Button title="Unblock">
           <MaterialIcons color="secondary" icon="verified_user" size={20}/>
       </Button>
       </div>
     )
    },
  };

  return (
    <div className={classes.root}>
      <Sidebar />
      <main className={classes.content}>
      <div className={classes.toolbar} />
      <Bread data={br} />
      {/* <Avatar alt="Trevor Henderson" src="/faces/5.jpg" /> */}
       <h1>User Details</h1>
       <Datatable title="User List" data={data} columns={columns} options={options}/>
      </main>
    </div>
    
   
  );
}


// WEBPACK FOOTER //
// ./src/Pages/UserTripsList.js